import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider/gala'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class GalaApi {

    static async loadProducts({ data = undefined, ...params }) {
        return await fetchService({ url: '/loadproducts', method: 'POST', data, ...params })
    }

    static async addStocks({ data = { data: '*', skladName: 'String' }, ...params }) {
        return await fetchService({ url: '/addstocks', method: 'POST', data, ...params })
    }


}